<script>
	import CallPlayer from "$lib/components/CallPlayer.svelte";

	export let calls = [];

	const formatCallStart = (value) => {
		if (!value) return "";
		const date = new Date(value);
		if (Number.isNaN(date.getTime())) return value;
		return date.toLocaleString(undefined, {
			dateStyle: "medium",
			timeStyle: "short",
		});
	};
</script>

{#if Array.isArray(calls) && calls.length}
	<div class="space-y-4">
		{#each calls as call, index (call.callId || index)}
			<div class="collapse collapse-arrow rounded-xl bg-base-300">
				<input type="checkbox" />
				<div class="collapse-title flex flex-col gap-1">
					<div
						class="flex flex-wrap items-center gap-3 justify-between"
					>
						<div>
							<p
								class="text-xs uppercase tracking-wide text-base-content/60"
							>
								Call {index + 1}
							</p>
							<h4 class="text-base font-semibold">
								{formatCallStart(call.startTime) || call.callId}
							</h4>
						</div>
					</div>
					{#if call.actionItems?.length}
						<p class="text-xs text-base-content/60">
							Action Items: {call.actionItems.join(", ")}
						</p>
					{/if}
				</div>
				<div class="collapse-content space-y-4">
					{#if call.summary}
						<p class="text-xs sm:text-sm max-w-xl">
							{call.summary}
						</p>
					{/if}
					<CallPlayer
						src={call.recordingUrl}
						waveforms={call.recordingWaveforms}
						transcript={call.conversationalTranscript}
					/>
				</div>
			</div>
		{/each}
	</div>
{:else}
	<p class="text-sm text-base-content/70">
		No embedded calls recorded for this case.
	</p>
{/if}
